import { defineMessages } from 'react-intl';

type MessageKeys = 'copy' | 'copied' | 'copiedToClipboard';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	copy: {
		id: 'fabric.editor.ai.config.item.action.copyResponse',
		defaultMessage: 'Copy',
		description:
			'Label for the copy icon button in the generative AI modal that copies the AI-generated response text to the clipboard.',
	},
	copied: {
		id: 'fabric.editor.ai.config.item.action.responseCopied',
		defaultMessage: 'Copied!',
		description:
			'Confirmation label shown on the copy icon button after the AI-generated response has been successfully copied to the clipboard.',
	},
	copiedToClipboard: {
		id: 'fabric.editor.ai.config.item.action.responseCopiedToClipboard',
		defaultMessage: 'Copied to clipboard',
		description:
			'Tooltip or status text displayed after the AI-generated response has been copied, confirming the copy action was successful.',
	},
});

export default message;
